(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('productionMenu', {
        templateUrl: 'views/components/views/productionMenu/productionMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
